import { StyleRules } from '@material-ui/core/styles';
import { SvgIconClassKey } from '@material-ui/core/SvgIcon';

import { core as theme } from '../styles/core';

export const MuiSvgIcon: Partial<StyleRules<SvgIconClassKey>> = {
  root: {
    fontSize: '1.25rem',
  },
  colorAction: {
    color: theme.palette.grey[500],
  },
  fontSizeSmall: {
    fontSize: '1rem',
  },
  fontSizeLarge: {
    fontSize: '1.5rem',
  },
};
